import React, { Suspense, lazy } from 'react';
import { PdfLoadError } from '@/components/PdfPreview/PdfLoadError';
import { PageSpinner } from '@/components/Spinner/PageSpinner';

const IS_IOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

const IsolatedPdfPages = lazy(() =>
  import('./IsolatedPdfPages')
    .then((module) => ({ default: module.IsolatedPdfPages }))
    .catch(() => ({ default: PdfLoadError })),
);

interface Props {
  url: string;
  title: string;
}

export const PdfPreview: React.FC<Props> = ({ url, title }) => {
  if (navigator.pdfViewerEnabled && !IS_IOS) {
    return <iframe src={url} title={title} className="size-full border-0" />;
  }

  return (
    <Suspense fallback={<PageSpinner />}>
      <IsolatedPdfPages url={url} />
    </Suspense>
  );
};
